/*! @pentacode/ui v0.1.0 */
// ../../node_modules/.pnpm/@tanstack+charts@1.1.0_lit@3.3.3_react-dom@19.2.0_react@19.2.0__react@19.2.0/node_modules/@tanstack/charts/dist/stack.js
function e(e = {}) {
	return {
		type: "stack",
		...e
	};
}
export { e as t };

//# sourceMappingURL=stack-Bwmp8HrU.js.map